<template>
	<div class="discar modal-2" v-if='getModalCall'>
		<div class="modal-content-my">
			<form class='form-modal' v-on:submit.prevent="sendCall">
				<div class="modal-head">
					<h4 class="title-text">Discar</h4>
					<span @click='btnClose' class='closeBtn'>&times;</span>
				</div>

				<div class="row">
					<div class="col-md-12 custom-checkclient">
						<span>É um cliente cadastrado no SenseData ?</span>
						<input type="checkbox" v-model="isClient">
					</div>
				</div>

				<hr>

				<div class="row" v-if="isClient">
					<div class="col-md-12 form-group">
						<label>ID do Cliente:</label>
						<input class='form-control' v-model="clientID">
					</div>
				</div>
				
				<div class="row" v-if="isClient">
					<div class="col-md-12 form-group">
						<label>Nome do Cliente:</label>
						<input class='form-control' v-model="clientName">
					</div>
				</div>

				<div class="row">
					<div class="col-md-9 form-group">
					<label for="phoneCall">Telefone:</label>
						<input id="phoneCall" class='esquerda form-control' type="text" placeholder="Telefone">
					</div>
					<div class="col-md-2 form-group" style="margin-top: 30px">
						<button @click="sendCall" class="btn btn-success" type="button">Discar </button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import phoneClient from '../../../store/modules/phoneClient';
const connection = io.connect(`${location.protocol}//${location.hostname}:3002/`);

export default {
	data() {
		return {
			isClient: false,
			clientID: "",
			clientName: "",
		}
	},
	computed: {
		...mapGetters([
			'getModalCall',
			'getChannel',
			'getExtension'
		])
	},
	methods: {
		...mapActions([
			'settModalCall',
			'setChannel',
		]),
		btnClose() {
			this.settModalCall();
		},
		formatPhoneToCall(phone) {
			let newPhone = phone.replace(/\D/g, "");
			newPhone = newPhone.slice(0, 2) == "55" ? newPhone.slice(2) : newPhone;
			return newPhone.slice(0, 2) == "11" ? newPhone.slice(2) : newPhone;
		},
		sendCall() {
			const phone = this.formatPhoneToCall(document.getElementById('phoneCall').value);
			connection.emit('OriginateTab', {
				calltype: 'outgoing',
				extension: this.getExtension(),
				phone: phone
			});

			phoneClient.mutations.setClientInAttendance({
				id: this.clientID,
				name: this.clientName,
				phone: phone,
				client_registered: false
			});
			
			this.settModalCall();
			this.clientID = "";
			this.clientName = "";
		}
	}
}
</script>

<style scoped>

.custom-checkclient {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0px 16px;
}

.custom-checkclient input {
	width: 10%;
	height: 25px;
}

</style>
